export default {
    coreBaseUrl: (commit, state, rootState) => {
        if (rootState.subscriptionManagement.subscriptionInfo?.tenantId) {
            return `${import.meta.env.VITE_CORE_URL_PATTERN?.replace('{id}', rootState.subscriptionManagement.subscriptionInfo?.tenantId)}`;
        }

        return '';
    },
};
